<template>
  <section class="admin-content" id="contact-search">
    <!-- <Navbar/> -->
    <main class="admin-main">
      <div class="col-md-12 d-flex align-items-center justify-content-between mb-2">
        <button
          type="button"
          class="btn btn-info"
          @click="AllSync"
          :disabled="disabled"
        >
          Sync All {{ students.length }} Enrollees
        </button>
        <span class="text-muted small">
          Showing {{ pagedStudents.length }} of {{ students.length }} enrollees
        </span>
      </div>

      <div class="col-md-12" v-show="showsync">
        <div class="card m-b-30 mb-8">
          <p class="h5 text-info text-center">
            Syncing in Progress -- {{ this.students.length }} remaining
          </p>

          <b-progress
            :value="syncvalue"
            :max="synctotal"
            show-progress
            animated
            height="2rem"
          ></b-progress>
          <br />
          <p><strong>Total to be Synced:</strong> {{ synctotal }}</p>
          <p><strong>Successfully Synced:</strong> {{ syncvalue }}</p>
        </div>
      </div>
      <section>
        <div class="container row">
          <div class="table-responsive">
            <table class="table align-td-middle table-card">
              <thead>
                <tr>
                  <th>Avatar</th>
                  <th>Name</th>
                  <th>User Type</th>
                  <th>Plan Type</th>
                  <th>Date of Birth || Date of Expiry</th>
                  <th>Phone Number</th>
                  <th>Sector</th>
                  <!-- <th>Dep</th> -->
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="student in pagedStudents" v-bind:key="student.id">
                  <td>
                    <div class="avatar avatar-md">
                      <img
                        :src="getImageSrc(student.user_image)"
                        class="avatar-img avatar-md rounded-circle"
                        alt=""
                        onerror="this.onerror=null; this.src='/assets/img/claimify_logo.png'"
                      />
                    </div>
                  </td>
                  <td>{{ student.firstname }} {{ student.lastname }}
                     <!-- {{student.place_of_work}} -->
                      </td>
                  <td>{{ student.type }}</td>
                  <td>{{ student.provider_id }}</td>
                  <td>{{student.dob}} || {{student.expiry_date}} </td>
                  <td>{{ student.phone_number }}</td>
                  <td ><span v-if="student.type == 'client'">{{ student.sector }}</span> </td>
                  <!-- <td>{{student.dependent_rel_type}}</td> -->
                  <td>
                    <button
                      type="button"
                      class="btn btn-info"
                      :disabled="disabled"
                      @click="syncUser(student)"
                      v-if="student.type == 'client'"
                    >
                      <i class="fe fe-refresh-cw"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-default"
                      @click="editUser(student)"
                      v-if="student.type == 'client'"
                    >
                      <i class="fe fe-edit"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger"
                      @click="remove(student)"
                    >
                      <i class="fe fe-delete"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="d-flex justify-content-between align-items-center mt-3" v-if="totalPages > 1">
            <button class="btn btn-outline-secondary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
              &laquo; Previous
            </button>
            <span class="text-muted small">Page {{ currentPage }} of {{ totalPages }}</span>
            <button class="btn btn-outline-secondary btn-sm" @click="currentPage++" :disabled="currentPage === totalPages">
              Next &raquo;
            </button>
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="spinner"
              :can-cancel="false"
              :is-full-page="true"
            ></loading>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>
<script>
// const synctotal = this.students.length;
import { StudentService } from "../../../service/student_service";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import { Capacitor } from "@capacitor/core";
let agency = JSON.parse(localStorage.getItem("agency"));

export default {
  components: {
    Loading,
  },
  name: "Student",
  props: {
    students: {
      required: true,
      type: Array,
    },
  },
  data: function () {
    return {
      disabled: false,
      newStudent: null,
      showsync: false,
      syncvalue: 0,
      synctotal: 0,
      user: null,
      fullPage: true,
      sector: "",
      show: false,
      currentPage: 1,
      pageSize: 20,
      syncInProgress: false,
      syncIntervalId: null,

      isLoading: false,
      newarray: {
        data: "",
      },

      service: new StudentService(),
    };
  },

  beforeMount: function () {
    // let total = this.students.length;
    // localStorage.setItem('synctotal', total)
    // this.synctotal = localStorage.getItem('synctotal')
  },
  computed: {
    pagedStudents() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.students.slice(start, start + this.pageSize);
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.students.length / this.pageSize));
    },
  },

  watch: {
    students() {
      this.currentPage = 1;
    },
  },

  methods: {
    getImageSrc(path) {
      if (!path) return '/assets/img/claimify_logo.png';
      if (path.startsWith('data:') || path.startsWith('blob:') || path.startsWith('http')) {
        return path;
      }
      try {
        return Capacitor.convertFileSrc(path);
      } catch {
        return path;
      }
    },

    async resolveImageForSync(imagePath) {
      if (!imagePath) return imagePath;
      if (imagePath.startsWith('data:') || imagePath.startsWith('http')) return imagePath;
      try {
        const webUrl = Capacitor.convertFileSrc(imagePath);
        const response = await fetch(webUrl);
        const blob = await response.blob();
        return await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        });
      } catch {
        return imagePath;
      }
    },

    AllSync() {
      if (confirm("Are you sure you want to start syncing?")) {
        this.synctotal = this.students.length;
        localStorage.setItem("synctotal", this.synctotal);
        this.syncvalue = 0;
        this.showsync = true;
        this.syncInProgress = false;

        // Clear any stale interval before starting
        if (this.syncIntervalId) clearInterval(this.syncIntervalId);
        this.syncIntervalId = setInterval(() => this.autoSync(), 10000);

        // Kick off immediately without waiting for the first 10s tick
        this.autoSync();
      }
    },

    async autoSync() {
      // Guard: skip if a sync request is already in-flight
      if (this.syncInProgress) return;

      if (this.students.length === 0) {
        this.showsync = false;
        this.disabled = false;
        clearInterval(this.syncIntervalId);
        this.syncIntervalId = null;
        this.$toasted.info("Syncing Completed Successfully!", {
          position: "top-center",
          duration: 5000,
        });
        this.$router.push("/employee-dashboard");
        return;
      }

      this.syncInProgress = true;
      this.disabled = true;
      const singlesync = this.students[0];
      const resolvedImage = await this.resolveImageForSync(singlesync.user_image);

      try {
        await this.axios.post("/api/v1/auth/syncUser", {
          agency_id: singlesync.agency_id,
          nimc_number: singlesync.nimc_number,
          firstname: singlesync.firstname,
          lastname: singlesync.lastname,
          middlename: singlesync.middlename,
          email: singlesync.email,
          user_image: resolvedImage,
          phone_number: singlesync.phone_number,
          type: singlesync.type,
          provider_id: singlesync.provider_id,
          state: agency.state,
          role: 0,
          password: "euhler",
          localgovt: singlesync.localgovt,
          ward: singlesync.ward,
          blood: singlesync.blood,
          dob: singlesync.dob,
          expiry_date: singlesync.expiry_date,
          address1: singlesync.address,
          occupation: singlesync.occupation,
          education: singlesync.education,
          place_of_work: singlesync.place_of_work,
          salary_number: singlesync.salary_number,
          genotype: singlesync.genotype,
          weight: singlesync.weight,
          gender: singlesync.gender,
          sector: singlesync.sector,
          plan_type: singlesync.plan_type,
          sectorType: singlesync.sectorType,
          org_id: singlesync.org_id,
          marital_status: singlesync.marital_status,
          category_of_vulnerable_group: singlesync.category_of_vulnerable_group,
          enrolled_by: singlesync.enrolled_by,
          dependent_rel_type: singlesync.dependent_rel_type,
          dependent_gender: singlesync.dependent_gender,
          dependent_dob: singlesync.dependent_dob,
        });
        this.$toasted.info("One synced!", { position: "top-center", duration: 3000 });
        this.syncvalue++;
        await this.removegroupsync(singlesync);
      } catch (error) {
        const errormessage = error.response && error.response.data && error.response.data.message;
        if (errormessage === "user exist") {
          // Already on server — remove locally so we don't retry
          await this.removegroupsync(singlesync);
        } else {
          this.$toasted.info("Network error — will retry in 10s", {
            position: "top-center",
            duration: 7000,
          });
        }
      } finally {
        // Always release the lock so the next interval tick can proceed
        this.syncInProgress = false;
      }
    },
    async syncUser(student) {
      this.isLoading = true;
      this.disabled = true;
      const resolvedImage = await this.resolveImageForSync(student.user_image);
      try {
        await this.axios.post("/api/v1/auth/syncUser", {
          agency_id: student.agency_id,
          nimc_number: student.nimc_number,
          firstname: student.firstname,
          lastname: student.lastname,
          middlename: student.middlename,
          email: student.email,
          user_image: resolvedImage,
          phone_number: student.phone_number,
          type: student.type,
          provider_id: student.provider_id,
          state: agency.state,
          role: 0,
          password: "euhler",
          localgovt: student.localgovt,
          ward: student.ward,
          blood: student.blood,
          salary_number: student.salary_number,
          dob: student.dob,
          expiry_date: student.expiry_date,
          address1: student.address,
          occupation: student.occupation,
          education: student.education,
          genotype: student.genotype,
          weight: student.weight,
          gender: student.gender,
          sector: student.sector,
          plan_type: student.plan_type,
          sectorType: student.sectorType,
          org_id: student.org_id,
          marital_status: student.marital_status,
          category_of_vulnerable_group: student.category_of_vulnerable_group,
          enrolled_by: student.enrolled_by,
          dependent_rel_type: student.dependent_rel_type,
          dependent_gender: student.dependent_gender,
          dependent_dob: student.dependent_dob,
        });
        this.$toasted.info("Enrollee synced successfully!", { position: "top-center", duration: 3000 });
        await this.removesync(student);
      } catch (error) {
        const errormessage = error.response && error.response.data && error.response.data.message;
        if (errormessage === "user exist") {
          // Already on the server from a previous attempt — remove locally
          this.$toasted.info("Already synced — removing from offline list.", { position: "top-center", duration: 3000 });
          await this.removesync(student);
        } else {
          this.$toasted.error("Sync failed. Please check your connection and try again.", {
            position: "top-center",
            duration: 5000,
          });
        }
      } finally {
        this.isLoading = false;
        this.disabled = false;
      }
    },

    editUser(student) {
      localStorage.setItem("editUser", JSON.stringify(student));
      this.$router.push("/edit-offline");
    },
    async remove(student) {
      if (confirm("Are you sure you want to delete?")) {
        const noOfStudentRemoved = await this.service.removeStudent(student.id);
        if (noOfStudentRemoved > 0) {
          this.$emit("remove-item");
        }
      }
    },
    async removesync(student) {
      this.disabled = false;
      const noOfStudentRemoved = await this.service.removeStudent(student.id);
      if (noOfStudentRemoved > 0) {
        this.$emit("remove-item");
      }
    },
    async removegroupsync(student) {
      const noOfStudentRemoved = await this.service.removeStudent(student.id);
      if (noOfStudentRemoved > 0) {
        this.$emit("remove-item");
      }
    },
  },
  created() {
    //
  },
};
</script>
<style scoped>
.spacer {
  margin-left: 5px;
  margin-top: 5px;
}
</style>
